import { Component, OnInit, HostBinding, ViewChild, OnDestroy } from '@angular/core';
import { BillComponent } from '../bill/bill.component';
import { Subscription } from 'rxjs';
import ace from 'ace-builds';
import { ThemeService, ThemeModel } from '../services/theme.service';
import { CurrentApiService } from 'dbweb-core';

@Component({
	selector: 'common-notice',
	templateUrl: './notice.component.html',
	styleUrls: ['./notice.component.scss']
})
export class NoticeComponent implements OnInit, OnDestroy {
	@ViewChild('bill', { static: true })
	bill: BillComponent;
	@HostBinding('class.c-notice') hostClass = true;
	options: any = { maxLines: 1000, printMargin: false };
	subs: Subscription[] = [];
	themeModel: ThemeModel;
	get content() {
		return this.bill.formGroup.get('Content').value;
	}
	set content(val: string) {
		this.bill.formGroup.get('Content').patchValue(val);
	}
	contentHTML: string;
	constructor(private theme: ThemeService, private api: CurrentApiService) {
		this.subs.push(
			this.theme.theme.subscribe(v => {
				this.themeModel = v.model;
			})
		);
	}
	ngOnDestroy() {
		this.subs.forEach(v => v.unsubscribe());
	}
	ngOnInit() {
		ace.config.set('basePath', '/front/assets/ace-builds/src-min-noconflict');
		this.subs.push(
			this.bill.init.subscribe(() => {
				if (this.bill.isBrowse()) {
					this.api.get<string>('get-content-html').subscribe(v => {
						this.contentHTML = v;
					});
					if (this.bill.typeRecord.Publish === '1') {
						this.api.get<boolean>('read-notice').subscribe();
					}
				}
			})
		);
	}
}
